import * as React from 'react'
import { cn } from '../../../lib/utils'

/**
 * Quiet monospace confidence readout for Plant entity metadata.
 * Deliberately not the pill-style `ConfidenceChip` used inside agent
 * reports — extraction confidence is bookkeeping metadata here, so it
 * sits at the right edge of a row in the same muted mono treatment the
 * plant pages use for ids and counts.
 */
export function ConfidenceValue({
  value,
  compact = false,
  className
}: {
  value: number | undefined
  compact?: boolean
  className?: string
}): React.ReactElement | null {
  if (value === undefined || !Number.isFinite(value)) return null
  const pct = Math.round(Math.max(0, Math.min(1, value)) * 100)
  return (
    <span
      title={`Extraction confidence: ${pct}%`}
      className={cn('shrink-0 font-mono text-11 tabular-nums text-ink-4', className)}
    >
      {compact ? `${pct}%` : `Confidence: ${pct}%`}
    </span>
  )
}
